import * as T from "types";
import { ArchivedChannel } from "@fotokite/archive-admin-api";
import { groupChannelsByCategory, isOldChannel } from "utils/channelCategories";

export const groupArchivedChannelsByDate = (
  archivedChannels: ArchivedChannel[]
) => {
  const byDate: T.IArchivedChannelByDate = {};
  archivedChannels.forEach((channel) => {
    const date = new Date(channel.timeOfArchiving).toLocaleDateString();
    if (!byDate[date]) {
      byDate[date] = [];
    }
    byDate[date].push(channel);
  });
  return byDate;
};

export const categorizedActiveChannels = (
  channels: string[],
  archivedChannels: string[]
) => {
  const activeChannels = channels.filter(
    (channel) => !isOldChannel(archivedChannels, channel)
  );
  return groupChannelsByCategory(activeChannels);
};
